import { formatDateTime } from './formatDateTime';

import { LUXON_FORMAT } from '../constants';

export function formatDate(isoDateTime, format = LUXON_FORMAT.DATE) {
  return formatDateTime(isoDateTime, format);
}
